module.exports = __webpack_public_path__ + "static/langojango-finnish-language-phrasebook-92bd6c8f6a6197294e60e1c9abd228d2.png";